// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2pZjd","log":"ModalInventoryLogs_log__2O1jA","date":"ModalInventoryLogs_date__-DCi6","userName":"ModalInventoryLogs_userName__2_Ewp"};